import { render } from "./PostPageCompositionApi.vue?vue&type=template&id=0a4f08a6"
import script from "./PostPageCompositionApi.vue?vue&type=script&lang=js"
export * from "./PostPageCompositionApi.vue?vue&type=script&lang=js"

import "./PostPageCompositionApi.vue?vue&type=style&index=0&id=0a4f08a6&lang=css"

import exportComponent from "D:\\secret\\py\\main_bot\\bank-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__